import type { SxProps } from '@mui/material';
import type { CSSProperties } from 'react';

const styles: Record<string, SxProps> = {
  footer: {
    // backgroundColor: '#f5f5f5',
    py: 4,
    mt: 4,
    borderTop: '1px solid #ddd',
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
  },
  logoContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  centerContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  sectionTitle: {
    fontWeight: 'bold',
    mb: 2,
    textAlign: 'center',
  },
  contactContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
  },
  contactItem: {
    display: 'flex',
    alignItems: 'center',
  },
  whatsAppIcon: {
    color: '#25D366',
    mr: 1,
  },
  emailIcon: {
    color: '#555',
    mr: 1,
  },
  socialIconsContainer: {
    display: 'flex',
    gap: 2,
    justifyContent: 'center',
  },
  paymentContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 1,
  },
  paymentGrid: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  paymentText: {
    fontWeight: '500',
    fontSize: '0.875rem',
  },
  icon: {
    fontSize: 30,
    mr: 1,
  },
  facebookIcon: {
    color: '#3b5998',
    fontSize: 30,
  },
  instagramIcon: {
    color: '#C13584',
    fontSize: 30,
  },
  twitterIcon: {
    color: '#1DA1F2',
    fontSize: 30,
  },
  secureItem: {
    pl: 0,
  },
  checkIcon: {
    minWidth: 30,
    color: '#4CAF50',
  },
  legalLinks: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 1,
    px: 2,
    textAlign: 'center',
  },
  legalLink: {
    color: 'text.primary',
    fontSize: '0.875rem',
  },
  legalSeparator: {
    color: 'text.secondary',
    fontSize: '0.875rem',
  },
  developedByContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    px: 2,
  },
  tribefyLink: {
    display: 'inline-flex',
    alignItems: 'center',
    textDecoration: 'none',
    ml: 1,
    color: '#123462',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  tribefyLogoMark: {
    width: 26,
    height: 26,
    borderRadius: 2,
    backgroundColor: '#1A4FA7',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    mr: 1,
  },
  tribefyLogoLetter: {
    fontWeight: 700,
    color: '#ffffff',
    fontSize: '0.95rem',
    lineHeight: 1,
  },
  tribefyText: {
    fontWeight: 600,
    fontSize: '0.95rem',
  },
};

// Estilos separados como objetos CSSProperties
export const logoStyle: CSSProperties = {
  height: 50,
  marginBottom: 8,
};

export const paymentIconStyle: CSSProperties = {
  height: 110,
  width: 'auto',
  maxWidth: 250,
  objectFit: 'contain',
};

export default styles;
